import { render } from "./Logic.vue?vue&type=template&id=5696bfa9"
import script from "./Logic.vue?vue&type=script&lang=js"
export * from "./Logic.vue?vue&type=script&lang=js"

import "./Logic.vue?vue&type=style&index=0&id=5696bfa9&scope=true&lang=scss"
script.render = render

export default script